import React = require('react');
import { isRequired } from '../../../../../../util/validators';
import { Col, Row } from 'react-bootstrap';

interface IPaymentErrorMessageProps {
  errorMessage: string,
  submitFailed: boolean,
  valid: boolean,
  quoteReference: string,
  showMissingDetails?: boolean,
}

export const PaymentErrorMessage = ({
                                      errorMessage,
                                      submitFailed,
                                      valid,
                                      quoteReference,
                                      showMissingDetails = false
                                    }: IPaymentErrorMessageProps) => {

  let fraudMessage = '';
  if (errorMessage && errorMessage.toLowerCase().includes('fraud')) {
    fraudMessage = 'Card Payment was unsuccessful: It appears that you are abroad already. Unfortunately we are unable to accept payments if you are already overseas. If this is not the case please call our customer services team on 0333 234 9913';
  }

  const formHasError = isRequired && submitFailed && !valid;

  const scrollToBottom = () => {
    window.scrollTo(0, document.body.scrollHeight);
  }

  const contactUs = () => {
    window.open('https://www.admiral.com/contact-us/travel', '_blank')
  }

  const renderGatewayErrorMessage = () => {
    return (
      <Row>
        <Col>
          <p><b>We were unable to process your payment request.</b></p>
          <p>No payment has been taken and no insurance cover is in place.</p>
          <p style={{ margin: '20px 0 20px 0' }}>
            <b>
              <span onClick={scrollToBottom} className={'link-element'}>Click here to try again</span>
            </b>
          </p>
          <p>If you experience any further problems, please <span
            onClick={contactUs} className={'link-element'}>contact us</span> so we can help you further.
          </p>
          <p>Your quote details have been saved – quote Ref {quoteReference}</p>
        </Col>
      </Row>
    )
  }

  const renderDeclinePaymentErrorMessage = () => {
    return (
      <Row>
        <Col>
          <p><b>Your payment has been declined by your bank.</b></p>
          <p className={'margin-bottom'}>No payment has been taken and no insurance cover is in place.</p>
          <p><b><span onClick={scrollToBottom}
                      className={'link-element'}>Click here</span> to
            try again or change your card details.</b></p>
          <p>Your quote details have been saved – quote ref: {quoteReference}</p>
        </Col>
      </Row>
    )
  }

  return (
    <>
      {(formHasError || errorMessage) && (
        <div className="error-block-container">
          <h1>Whoops!</h1>
          {formHasError && (<p>Missing something? Please check the areas marked in red before you continue.</p>)}
          {errorMessage && fraudMessage && (
            <p>{fraudMessage}</p>
          )}

          {errorMessage && errorMessage !== 'Payment Error' && (
            <>
              {renderGatewayErrorMessage()}
            </>
          )}

          {errorMessage && errorMessage === 'Payment Error' && (
            <>
              {renderDeclinePaymentErrorMessage()}
            </>
          )}

        </div>
      )}
      {showMissingDetails && (
        <div className="error-block-container missing-details">
          <h1>Whoops!</h1>
          <Row>
            <Col>
              <p>Please check the areas marked in red and save your changes before proceeding with payment.</p>
            </Col>
          </Row>
        </div>
      )}
    </>
  )

}
